
import ProfileIcons from "../../assets/Icons/FeedIcons/ProfileIcons";
import StaticImages from "../../assets/StaticImages";

export const interests = [
  {
    name: "Anny",
    likeType: "experienceLike",
    message: "Hey there! How about we set sail on a sea of flavors together?",
    image: StaticImages.Display2,
    images: [StaticImages.Display2, StaticImages.Display2],
    bio: "this is a fun bio",
    activeStatus: "Active",
    vitals: [
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "27",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Man",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: `5'11"`,
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Athlete",
      },

      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Bang Sue",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Asians",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "No",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "No",
      },
      // ... other vitals
    ],
    virtues: [
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Branch Manager at Wipro",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "DPS",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "English, Thai",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Looking for casual",
      },

      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Single",
      },
      // ... other virtues
    ],
    experiences: [
      {
        image: StaticImages.Exp1,
        title: "Brunch at rooftop",
      },
      {
        image: StaticImages.Exp2,
        title: "Brunch at rooftop",
      },
      {
        image: StaticImages.Exp3,
        title: "Brunch at rooftop",
      },
    ],
  },
  {
    name: "Anny",
    likeType: "profileLike",
    message: "Hey there! How about we set sail on a sea of flavors together?",
    image: StaticImages.Display2,
    images: [StaticImages.Display2, StaticImages.Display2],
    bio: "this is a fun bio",
    activeStatus: "Active",
    vitals: [
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "27",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Man",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: `5'11"`,
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Athlete",
      },

      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Bang Sue",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Asians",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "No",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "No",
      },
      // ... other vitals
    ],
    virtues: [
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Branch Manager at Wipro",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "DPS",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "English, Thai",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Looking for casual",
      },

      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Single",
      },
      // ... other virtues
    ],
    experiences: [
      {
        image: StaticImages.Exp1,
        title: "Brunch at rooftop",
      },
      {
        image: StaticImages.Exp2,
        title: "Brunch at rooftop",
      },
      {
        image: StaticImages.Exp3,
        title: "Brunch at rooftop",
      },
    ],
  },
  {
    name: "Anny",
    likeType: "profileLike",
    message: "Hey there! How about we set sail on a sea of flavors together?",
    image: StaticImages.Display2,
    images: [StaticImages.Display2, StaticImages.Display2],
    bio: "this is a fun bio",
    activeStatus: "Active",
    vitals: [
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "27",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Man",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: `5'11"`,
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Athlete",
      },

      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Bang Sue",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Asians",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "No",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "No",
      },
      // ... other vitals
    ],
    virtues: [
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Branch Manager at Wipro",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "DPS",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "English, Thai",
      },
      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Looking for casual",
      },

      {
        icon: <ProfileIcons.BirthdayIcon />,
        label: "Single",
      },
      // ... other virtues
    ],
    experiences: [
      {
        image: StaticImages.Exp1,
        title: "Brunch at rooftop",
      },
      {
        image: StaticImages.Exp2,
        title: "Brunch at rooftop",
      },
      {
        image: StaticImages.Exp3,
        title: "Brunch at rooftop",
      },
    ],
  },
];
